<div class="image-banner-container">
  <img width="100%" [src]="bannerImageAssetPath" alt="" class="image-banner lazy-load loaded" typeof="foaf:Image"
    data-was-processed="true">
</div>

<div class="login-content">
  <mat-card class="login-card">
    <mat-card-header>
      <mat-card-title><b>{{title}} Login</b></mat-card-title>
    </mat-card-header>
    <mat-card-content>

      <mat-accordion>
        <mat-expansion-panel [expanded]="externalLoginUrl">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Login with Forestry Single Sign On
            </mat-panel-title>
            <mat-panel-description>
              Log in with your Forestry England account via SSO
            </mat-panel-description>
          </mat-expansion-panel-header>
          <a mat-raised-button color="primary" [href]="externalLoginUrl">Login</a>
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="!externalLoginUrl">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Login with Username and Password
            </mat-panel-title>
            <mat-panel-description>
              Log in with eAssets Username and Password
            </mat-panel-description>
          </mat-expansion-panel-header>
          <form class="form" autocomplete="off">
            <table class="full-width" cellspacing="0">
              <tr>
                <td>
                  <mat-form-field class="full-width">
                    <input matInput #usernameInput placeholder="Username" [(ngModel)]="username" name="username"
                      (keyup.enter)="onEnter($event)" required autocomplete="off">
                  </mat-form-field>
                </td>
              </tr>
              <tr>
                <td>
                  <mat-form-field class="full-width">
                    <mat-pass-toggle-visibility #toggleVisbilityNewPassword matSuffix>
                    </mat-pass-toggle-visibility>
                    <input matInput #passwordInput placeholder="Password" [(ngModel)]="password" type="password"
                      name="password" (keyup.enter)="onEnter($event)" [type]="toggleVisbilityNewPassword.type" required
                      autocomplete="off">
                    <mat-hint *ngIf="toggleVisbilityNewPassword.type == 'text'" class="hint">
                      Please ensure that no one can observe your password
                    </mat-hint>
                  </mat-form-field>
                </td>
              </tr>
            </table>
            <span *ngIf="toggleVisbilityNewPassword.type == 'text'"><br></span>
            <button mat-raised-button (click)="login()" color="primary">Login</button>
          </form>
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Register
            </mat-panel-title>
            <mat-panel-description>
              Register for an account
            </mat-panel-description>
          </mat-expansion-panel-header>
          <p>If you are new to Forestry England, you need to log a request with Ops Admin to create your account.</p>
          <a mat-raised-button color="primary"
            href="mailto:{{fcItEmail}}?subject={{fcItSubject}}&body={{fcItBody}}">Email Ops Admin</a>
        </mat-expansion-panel>
      </mat-accordion>

    </mat-card-content>
  </mat-card>
</div>